import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { HorseShowArenaService } from '../../providers/horse-show-arena.service';
import { Horse_show_arena } from '../../models/horse_show_arena';

@Component({
  standalone: false,
  selector: 'app-arena-picker',
  templateUrl: './arena-picker.component.html',
styleUrls:  ['./arena-picker.component.css']
})
export class ArenaPickerComponent implements OnInit, OnChanges {

	@Input() horse_show_id: string = "";
	arena_list: Horse_show_arena[] = [];
  @Output() arena_selected$: EventEmitter<number> = new EventEmitter<number>();
  selected_arena_number: number = 0;

  constructor(private horseShowArenaService: HorseShowArenaService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.horse_show_id != undefined){
        this.horseShowArenaService.getListForHorseShow(this.horse_show_id).then(arena_list => {
        this.arena_list = arena_list;
        if(this.arena_list.length > 0){
          this.selected_arena_number = 0;
        }
      }).catch(error => {
        console.log(error);
      });
    }

  }

  handleSelectionChange(){
    this.arena_selected$.emit(this.selected_arena_number);
  }


}
